import { useMemo } from 'react';
import type { GlobalAttributes } from './constants.js';
import { getGlobalAttributes } from './getGlobalAttributes.js';
import type { GlobalAttributesT } from './getGlobalAttributes.js';

export const useGetGlobalAttributes = <T, S = Element>(
  props: T,
  overrides?: Partial<GlobalAttributes<CallableFunction>>,
): GlobalAttributesT<S> => {
  const componentGlobalAttributes: GlobalAttributesT<S> = useMemo(
    () => getGlobalAttributes(props, overrides),
    [props, overrides],
  );
  return componentGlobalAttributes;
};
